module.exports = __webpack_public_path__ + "static/media/location-maps-letter-d-arrow-serr1.41e26fcd.png";